/** Shared UX for Configuration admin list tables (pagination, floating row menus). */

export const CONFIG_LIST_PAGE_SIZE = 10;

/** Standard flags tab — fits tp-container-small */
export const FLAGS_DETAIL_TABLE_GRID =
  'minmax(0, 0.75fr) minmax(0, 0.95fr) minmax(0, 1.35fr) minmax(0, 0.55fr) minmax(0, 0.95fr) minmax(0, 0.9fr) minmax(0, 1.1fr) minmax(0, 1.1fr)';

/** Profile / ticket audit log (6 columns) */
export const AUDIT_LOG_DETAIL_GRID =
  'minmax(0, 1.2fr) minmax(0, 1.1fr) minmax(0, 1fr) minmax(0, 1.35fr) minmax(0, 0.95fr) minmax(0, 2.1fr)';

/** Fraud case — moderation & flags tab */
export const FRAUD_MODERATION_FLAGS_GRID =
  'minmax(0, 0.9fr) minmax(0, 1fr) minmax(0, 0.95fr) minmax(0, 0.55fr) minmax(0, 1.2fr) minmax(0, 1.35fr) minmax(0, 1.1fr) minmax(0, 1.1fr) minmax(56px, auto)';

/** Fraud case audit log (5 columns, no user type) */
export const FRAUD_AUDIT_LOG_DETAIL_GRID =
  'minmax(0, 1.2fr) minmax(0, 1.1fr) minmax(0, 1fr) minmax(0, 1.15fr) minmax(0, 2.1fr)';

/** Security incident — linked moderation cases */
export const INCIDENT_MODERATION_CASES_GRID =
  'minmax(0, 0.85fr) minmax(0, 1fr) minmax(0, 1.15fr) minmax(0, 0.55fr) minmax(0, 0.9fr) minmax(56px, auto)';

export function getDetailTablePagination(totalCount, currentPage) {
  const totalPages = Math.max(1, Math.ceil(totalCount / CONFIG_LIST_PAGE_SIZE));
  const effectivePage = Math.min(currentPage, totalPages);
  const startIndex = (effectivePage - 1) * CONFIG_LIST_PAGE_SIZE;
  return {
    totalPages,
    effectivePage,
    rangeStart: totalCount === 0 ? 0 : startIndex + 1,
    rangeEnd: Math.min(effectivePage * CONFIG_LIST_PAGE_SIZE, totalCount),
    showPagination: totalCount > CONFIG_LIST_PAGE_SIZE,
    paginate: (items) => items.slice(startIndex, startIndex + CONFIG_LIST_PAGE_SIZE),
  };
}

const FLOATING_MENU_APPROX_HEIGHT = 132;
const FLOATING_MENU_MIN_WIDTH = 140;

/**
 * Position for a fixed dropdown aligned to the right edge of the anchor (⋮ button).
 * Flips above the anchor when there is not enough space below the viewport.
 */
export function computeFloatingMenuPosition(anchorEl) {
  const rect = anchorEl.getBoundingClientRect();
  const gap = 4;
  let top = rect.bottom + gap;
  if (
    top + FLOATING_MENU_APPROX_HEIGHT > window.innerHeight - 8 &&
    rect.top > FLOATING_MENU_APPROX_HEIGHT + gap + 8
  ) {
    top = rect.top - FLOATING_MENU_APPROX_HEIGHT - gap;
  }
  let left = rect.right - FLOATING_MENU_MIN_WIDTH;
  left = Math.max(8, Math.min(left, window.innerWidth - FLOATING_MENU_MIN_WIDTH - 8));
  return { top, left };
}

/** Selector for row action anchor + portaled menu (outside-click detection). */
export const CONFIG_ROW_ACTIONS_WRAP_SELECTOR = '[data-config-row-actions-wrap]';
